/* eslint-disable no-unused-vars */
import { memo, useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import CampaignSection from 'components/campaign/campaignSection/CampaignSection';
import TargetingSectionTabs from 'components/campaign/targetingSection/general/TargetingSectionTabs';
import { useTranslation } from 'react-i18next';
import { CampaignSectionAction } from 'components';
import {
  targetingNavigation,
  targeting_title_icon_onBoadring,
  targeting_title_icon_onGoing,
  checkCurrentTargetingSectionAndSetErrorField,
} from 'utils';
import { selectTargetingTab } from 'store/selectors';
import { targetingPlacementsActions } from 'store/actions';
import { campaignEnvironment } from 'constants';

const GeneralTargetingSection = ({ expanded, setExpanded, handleChange, environment, error }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const currentTab = useSelector(selectTargetingTab);

  const isOnBoarding = useSelector(
    (state) => state.general.mainCampaignObject?.currentCampaignObj?.isOnBoarding,
  );
  // const isWebsite = useSelector(
  //   (state) => state.general.mainCampaignObject?.currentCampaignObj?.isWebsite,
  // );

  const targeting_title_icon_onGoing_without_ExcludeRules = useMemo(() => {
    if (
      environment === campaignEnvironment.duplicate ||
      environment === campaignEnvironment.new_empty
    ) {
      const { devices_os, exclude_rules } = targeting_title_icon_onGoing;
      const updatedTargeting = {
        ...targeting_title_icon_onGoing,
        devices_os: { ...exclude_rules },
      };
      delete updatedTargeting.exclude_rules;
      return updatedTargeting;
    }

    return targeting_title_icon_onGoing;
  }, [environment, targeting_title_icon_onGoing]);

  const handleChangeTab = (tab) => {
    if (checkCurrentTargetingSectionAndSetErrorField(currentTab)) {
      dispatch(targetingPlacementsActions.changeTab(tab));
    }
  };

  const handleClickBtn = () => {
    if (checkCurrentTargetingSectionAndSetErrorField(currentTab)) {
      targetingNavigation(currentTab, setExpanded, handleChangeTab, environment);
    }
  };

  useEffect(() => {
    if (environment === campaignEnvironment.edit && isOnBoarding !== undefined) {
      dispatch(
        targetingPlacementsActions.changeTab(isOnBoarding ? 'locations_languages' : 'placements'),
      );
    }
  }, [isOnBoarding, environment]);

  return (
    <CampaignSection
      error={error}
      expanded={expanded}
      isExpandable={true}
      handleChange={handleChange}
      title={t('campaign.targeting.title')}
      details={
        <TargetingSectionTabs
          currentTab={currentTab}
          setCurrentTab={handleChangeTab}
          environment={environment}
        />
      }
      actions={
        <CampaignSectionAction
          onClick={handleClickBtn}
          title={
            isOnBoarding
              ? targeting_title_icon_onBoadring[currentTab]?.title
              : targeting_title_icon_onGoing_without_ExcludeRules[currentTab]?.title
          }
          expanded={expanded}
          icon={
            isOnBoarding
              ? targeting_title_icon_onBoadring[currentTab]?.icon
              : targeting_title_icon_onGoing_without_ExcludeRules[currentTab]?.icon
          }
        />
      }
    />
  );
};

export default memo(GeneralTargetingSection);
